import React from "react";
import "./ConsultationServices.css";

const steps = [
  {
    number: 1,
    title: "Visite sur place",
    description:
      "Nous nous déplaçons sur le lieu du projet afin d'évaluer avec précision les besoins spécifiques de votre environnement.",
  },
  {
    number: 2,
    title: "Présentation des méthodes",
    description:
      "Nous détaillons les procédures pour chaque type d'intervention, afin de vous offrir une vision claire et structurée.",
  },
  {
    number: 3,
    title: "Assistance pendant les travaux",
    description:
      "Notre équipe vous accompagne en direct pour vous guider étape par étape avec des conseils pratiques.",
  },
  {
    number: 4,
    title: "Notre but",
    description:
      "Vous faire gagner du temps et de l'énergie en définissant un plan d'action clair, afin de réussir vos rénovations en toute sérénité.",
  },
];

export const Team = () => {
  return (
    <div id="Partenaires" className="text-center">
      <div>
        <div className="section-title">
          <h2>Consultation personnalisée</h2>
        </div>

        <section className="consultation-section">
          {/* ==== INTRO BLOCK ==== */}
          <div className="intro-block">
            <h2>Vous avez un projet de rénovation et souhaitez être accompagné à chaque étape ?</h2>
            <p>
              Avec notre <strong>service de consultation personnalisée</strong>, bénéficiez d’un{" "}
              <strong>diagnostic précis</strong>, de <strong>conseils techniques adaptés</strong> et
              d’un <strong>accompagnement sur mesure</strong>, quel que soit le corps de métier
              concerné.
            </p>
            <p>
              Faites confiance à notre équipe d’experts pour{" "}
              <strong>structurer, planifier et concrétiser votre projet en toute sérénité</strong>.
            </p>
          </div>

          {/* ==== STEPS TITLE ==== */}
          <div className="steps-title container">
            <h2>Voici ce que notre service comprend :</h2>
          </div>

          {/* ==== STEPS GRID ==== */}
          <div className="bgo">
            <div className="steps-grid">
              {steps.map((step) => (
                <div
                  key={step.number}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div
                    className={`step-card ${
                      step.number === 4 ? "highlight" : ""
                    }`}
                  >
                    <div className="step-number">{step.number}</div>
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
